import { API_URL, getAuthHeaders } from '../api';

export interface Device {
    id: string;
    club_id: string;
    court_id?: string;
    name: string;
    type: 'camera' | 'light' | 'access' | 'audio_matrix' | 'speaker' | 'screen' | 'other';
    ip_address?: string;
    port?: number;
    config: {
        username?: string;
        password?: string;
        stream_path?: string;
        protocol?: 'http' | 'rtsp' | 'rtmp' | 'hls' | 'tcp' | 'upnp';
        driver?: 'generic_http' | 'yamaha_mtx' | 'audac_touch' | 'bose_esp' | 'sonos';
        zones?: {
            id: string;      // Driver specific zone ID (e.g. "1", "zone_bar")
            name: string;    // Human readable name (e.g. "Bar Speakers")
            court_id?: string; // Mapped court
        }[];
        [key: string]: any;
    };
    position_x: number;
    position_y: number;
    rotation: number;
    status: 'active' | 'inactive' | 'error';
    is_public: boolean;
    created_at?: number;
}

export const devicesService = {
    listByClub: async () => {
        const res = await fetch(`${API_URL}/manager/devices`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to fetch devices");
        return res.json();
    },

    listPublicByClub: async (clubId: string) => {
        const res = await fetch(`${API_URL}/public/clubs/${clubId}/devices`);
        if (!res.ok) throw new Error("Failed to fetch public devices");
        return res.json();
    },

    create: async (data: any) => {
        const res = await fetch(`${API_URL}/manager/devices`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to create device");
        return res.json();
    },

    update: async (id: string, data: any) => {
        const res = await fetch(`${API_URL}/manager/devices/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to update device");
        return res.json();
    },

    delete: async (id: string) => {
        const res = await fetch(`${API_URL}/manager/devices/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to delete device");
    },

    control: async (id: string, action: 'ON' | 'OFF' | 'DIM' | 'UNLOCK', value?: number) => {
        const res = await fetch(`${API_URL}/manager/devices/${id}/control`, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ action, value })
        });
        if (!res.ok) throw new Error('Control failed');
        return res.json();
    }
};

